import { CaseDocument } from "pwapi";

import { CaseDocumentAdmin } from "custom-models";

import { shallowLeftDiff } from "shared/utils/formUtils";

export const historicalAssignableCategories = [
  CaseDocument.category.CASE_REPORT,
];

export const inputDisabledCategories = [
  CaseDocument.category.UNMERGED_CASE_REPORT,
  CaseDocument.category.PRELIMINARY_REPORT,
  CaseDocument.category.UNMERGED_PRELIMINARY_REPORT,
];

export const unassignableCategories = [
  ...inputDisabledCategories,
  CaseDocument.category.LOOSE_DOCUMENT,
  CaseDocument.category.DOC_CLINICAL,
  CaseDocument.category.DOC_INSURANCE,
  CaseDocument.category.LAB_REQUISITION,
];

export const autoAttachDocuments = [
  CaseDocument.category.DIF_REPORT,
  CaseDocument.category.FISH_REPORT,
  CaseDocument.category.MOLECULAR_REPORT,
  CaseDocument.category.CONSULTATION_REPORT,
  CaseDocument.category.LAB_REPORT,
  CaseDocument.category.ISH_REPORT,
  CaseDocument.category.TICK_REPORT,
  CaseDocument.category.IHC_REPORT,
];

export const attachableDocuments = [
  ...autoAttachDocuments,
  CaseDocument.category.OTHER,
  CaseDocument.category.CONSULT_LETTER,
  CaseDocument.category.CASTLE_REPORT,
];

export const internalDocuments = [
  CaseDocument.category.INTERNAL_DOCUMENT,
  CaseDocument.category.CASE_CORRECTION_REQUEST,
  CaseDocument.category.EXTRADEPARTMENTAL_REPORT,
];

export const canAttachDocument = (category: CaseDocument.category) => {
  return attachableDocuments.includes(category);
};

export const submissionFieldsForDocument = (
  _document: CaseDocumentAdmin,
  values?: Partial<CaseDocumentAdmin>,
  useMergeCaseReportWorkflow?: boolean
) => {
  if (!values) values = _document;

  const attach_to_case_report = getAttachToCaseReportforApi(
    values.attach_to_case_report,
    useMergeCaseReportWorkflow,
    values.category
  );

  return {
    case_id: values.case ? values.case.id : _document.case_id,
    case__accession: values.case
      ? values.case.accession
      : _document.case__accession,
    category: values.category || null,
    status: values.status || null,
    name: values.name || null,
    ...(attach_to_case_report === null
      ? {}
      : { attach_to_case_report: attach_to_case_report }),
  };
};

export const shallowDocumentComparison = (
  _document: CaseDocumentAdmin,
  values: Partial<CaseDocumentAdmin>,
  useMergeCaseReportWorkflow?: boolean
) => {
  const oldValues = submissionFieldsForDocument(
    _document,
    undefined,
    useMergeCaseReportWorkflow
  );
  const newValues = submissionFieldsForDocument(
    _document,
    values,
    useMergeCaseReportWorkflow
  );

  return shallowLeftDiff<ReturnType<typeof submissionFieldsForDocument>>(
    oldValues,
    newValues
  );
};

export const getAttachToCaseReportforApi = (
  attachToDocument?: boolean | null,
  useMergeCaseReportWorkflow?: boolean,
  category?: CaseDocumentAdmin["category"]
): string | null => {
  const test =
    useMergeCaseReportWorkflow &&
    attachToDocument !== undefined &&
    attachToDocument !== null &&
    canAttachDocument((category as CaseDocument.category) ?? "")
      ? attachToDocument
        ? "true"
        : "false"
      : null;

  return test;
};
